import pluralize from 'pluralize';
import { FormControl } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import AuthorizedAction from '../../AuthorizedAction.js';
import { calculatePercentage } from '../../../lib/utils.js';
import SubHeader from '../../SubHeader.jsx';
import styles from './StakeholdersParticipationHeader.module.css';

const StakeholdersParticipationHeader = ({
  initiative,
  handleSearchStakeholders,
  stakeholdersParticipations,
  activeStakeholderParticipationId,
}) => {
  let completedCount;
  let count;
  const stakeholderParticipation = stakeholdersParticipations.find(
    (stakeholder) => stakeholder.id === activeStakeholderParticipationId
  );
  const [currentLevelStakeholders, setCurrentLevelStakeholders] = useState([]);

  const updateCurrentLevelStakeholders = (currentId) => {
    if (currentId && stakeholderParticipation) {
      setCurrentLevelStakeholders(
        stakeholderParticipation.children.length
          ? stakeholderParticipation.children
          : [stakeholderParticipation]
      );
    } else setCurrentLevelStakeholders(stakeholdersParticipations);
  };

  useEffect(() => {
    updateCurrentLevelStakeholders(activeStakeholderParticipationId);
  }, [activeStakeholderParticipationId]);

  if (activeStakeholderParticipationId && stakeholderParticipation) {
    completedCount = stakeholderParticipation.leavesCompletedCount;
    count = stakeholderParticipation.leavesCount;
  } else {
    completedCount = initiative.stakeholderParticipationCompletedCount;
    count = initiative.stakeholderParticipationCount;
  }

  return (
    <SubHeader flexJustify small>
      <div className="flex">
        <h2>Participating Stakeholders</h2>
        <strong className="header-item bordered text-muted">
          Current Level:&nbsp;
          <span className="text-primary">
            {currentLevelStakeholders.length}{' '}
            {pluralize('Result', currentLevelStakeholders.length)}
          </span>
        </strong>

        {initiative.completionTracked &&
          initiative.project.manageProjectEntities && (
            <AuthorizedAction action="update" subject="changeImpact">
              <strong
                className={`header-item ${styles.completion} bordered text-muted`}
              >
                Completed:&nbsp;
                <span className="text-primary">
                  {calculatePercentage(completedCount, count)}%
                </span>
                <span className="text-primary">
                  {completedCount}/{count}
                </span>
              </strong>
            </AuthorizedAction>
          )}
      </div>
      <FormControl
        style={{ maxWidth: '500px' }}
        placeholder="Search"
        type="text"
        className="search-icon"
        onChange={handleSearchStakeholders}
        disabled={initiative.stakeholderParticipationCount === 0}
      />
    </SubHeader>
  );
};

export default StakeholdersParticipationHeader;
